import React from 'react';
import images from '../constants/images';

const Logo = ({ className = "h-12", showText = true }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <img 
        src={images.logo} 
        alt="Baseline MD" 
        className="h-full w-auto object-contain"
        onError={(e) => {
          console.warn("Logo image failed to load");
        }}
      />
      {showText && (
        <span className="font-Gibson font-bold text-2xl tracking-tight flex items-center">
          <span style={{ color: 'var(--clr-black)' }}>Baseline</span>
          <span style={{ 
            background: 'linear-gradient(135deg, var(--clr-main) 0%, var(--clr-black) 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            marginLeft: '4px'
          }}>MD</span>
        </span>
      )}
    </div>
  );
};

export default Logo;
